'use client';

import * as React from 'react';
import {
  EyeIcon,
  TargetIcon,
  BarChart3Icon,
  UsersIcon,
  ZapIcon,
  TrendingUpIcon
} from 'lucide-react';

import { BlurFade } from '~/components/fragments/blur-fade';
import { GridSection } from '~/components/fragments/grid-section';
import { SiteHeading } from '~/components/fragments/site-heading';

const FEATURES = [
  {
    icon: <EyeIcon className="size-5 shrink-0" />,
    title: 'Volledig overzicht',
    description:
      'Zie in één oogopslag waar elke deal staat, wat de waarde is en wat de volgende stap is. Geen verrassingen meer, altijd controle.'
  },
  {
    icon: <TargetIcon className="size-5 shrink-0" />,
    title: 'Fasebeheer',
    description:
      'Organiseer deals in duidelijke fasen en volg de voortgang. Van lead tot deal – zie precies waar elke kans staat in het proces.'
  },
  {
    icon: <BarChart3Icon className="size-5 shrink-0" />,
    title: 'Pipeline analyse',
    description:
      'Analyseer je pipeline op waarde, fase en verwachte sluitingsdatum. Identificeer knelpunten en kansen om je verkoop te optimaliseren.'
  },
  {
    icon: <UsersIcon className="size-5 shrink-0" />,
    title: 'Team samenwerking',
    description:
      'Wijs deals toe aan teamleden en werk samen aan het sluiten van deals. Iedereen ziet wat er moet gebeuren en wie waarvoor verantwoordelijk is.'
  },
  {
    icon: <ZapIcon className="size-5 shrink-0" />,
    title: 'Slimme automatisering',
    description:
      'Automatiseer herinneringen en notificaties voor belangrijke deals. Blijf op de hoogte van deadlines en mis geen kans meer.'
  },
  {
    icon: <TrendingUpIcon className="size-5 shrink-0" />,
    title: 'Voorspellingen',
    description:
      'Krijg inzicht in je verwachte omzet op basis van je pipeline. Plan beter en stel realistische doelen met data-gedreven voorspellingen.'
  }
];

export function SalesPipelineFeatures(): React.JSX.Element {
  return (
    <GridSection>
      <div className="container space-y-12 py-20 md:py-32">
        <SiteHeading
          badge="Unieke voordelen"
          title="Wat maakt Emma's Sales Pipeline anders?"
          description="Ontdek de krachtige functies die Emma biedt om je verkoopproces te optimaliseren en meer deals te sluiten."
        />

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((feature, index) => (
            <BlurFade
              key={index}
              inView
              delay={0.1 + index * 0.1}
              className="rounded-xl border bg-card p-6 shadow-sm transition-shadow hover:shadow-md"
            >
              <div className="mb-4 flex size-12 items-center justify-center rounded-xl border bg-background text-primary">
                {feature.icon}
              </div>
              <h3 className="mb-2 text-lg font-semibold">{feature.title}</h3>
              <p className="text-muted-foreground">{feature.description}</p>
            </BlurFade>
          ))}
        </div>
      </div>
    </GridSection>
  );
}
